import React from 'react';
import {
  Construction,
  Building,
  Building2,
  Boxes,
  Factory,
  Warehouse,
  Home,
  MapPin,
} from 'lucide-react';

const siteTypeConfig = {
  project_site: {
    label: 'Project Site',
    icon: Construction,
    infoBadgeColor: 'orange',
    color: {
      bg: 'bg-orange-100',
      text: 'text-orange-600',
      border: 'border-orange-200',
      hover: 'hover:bg-orange-50',
      badge: 'badge-warning',
    },
  },
  site_office: {
    label: 'Site Office',
    icon: Building,
    infoBadgeColor: 'blue',
    color: {
      bg: 'bg-blue-100',
      text: 'text-blue-600',
      border: 'border-blue-200',
      hover: 'hover:bg-blue-50',
      badge: 'badge-info',
    },
  },
  office: {
    label: 'Office',
    icon: Building2,
    infoBadgeColor: 'indigo',
    color: {
      bg: 'bg-indigo-100',
      text: 'text-indigo-600',
      border: 'border-indigo-200',
      hover: 'hover:bg-indigo-50',
      badge: 'badge-admin-primary',
    },
  },
  dfma_factory: {
    label: 'DfMA Factory',
    icon: Boxes,
    infoBadgeColor: 'purple',
    color: {
      bg: 'bg-purple-100',
      text: 'text-purple-600',
      border: 'border-purple-200',
      hover: 'hover:bg-purple-50',
      badge: 'badge-secondary',
    },
  },
  factory: {
    label: 'Factory',
    icon: Factory,
    infoBadgeColor: 'amber',
    color: {
      bg: 'bg-amber-100',
      text: 'text-amber-600',
      border: 'border-amber-200',
      hover: 'hover:bg-amber-50',
      badge: 'badge-warning',
    },
  },
  storage: {
    label: 'Storage',
    icon: Warehouse,
    infoBadgeColor: 'teal',
    color: {
      bg: 'bg-teal-100',
      text: 'text-teal-600',
      border: 'border-teal-200',
      hover: 'hover:bg-teal-50',
      badge: 'badge-success',
    },
  },
  dormitory: {
    label: 'Dormitory',
    icon: Home,
    infoBadgeColor: 'green',
    color: {
      bg: 'bg-green-100',
      text: 'text-green-600',
      border: 'border-green-200',
      hover: 'hover:bg-green-50',
      badge: 'badge-success',
    },
  },
};

const fallback = {
  label: 'Site',
  icon: MapPin,
  infoBadgeColor: 'gray',
  color: {
    bg: 'bg-gray-100',
    text: 'text-gray-600',
    border: 'border-gray-200',
    hover: 'hover:bg-gray-50',
    badge: 'badge-secondary',
  },
};

export function getSiteTypeIcon(type, className = 'w-4 h-4') {
  const Icon = (siteTypeConfig[type] || fallback).icon;
  return <Icon className={className} />;
}

export function getSiteTypeColor(type) {
  return (siteTypeConfig[type] || fallback).color;
}

export function getSiteTypeLabel(type) {
  return (siteTypeConfig[type] || fallback).label;
}

export function getSiteTypeInfoBadgeColor(type) {
  return (siteTypeConfig[type] || fallback).infoBadgeColor;
}

export const siteTypeOptions = Object.entries(siteTypeConfig).map(
  ([value, { label, icon: Icon }]) => ({
    value,
    label,
    icon: <Icon className="w-4 h-4" />,
  })
);

export default siteTypeConfig;
